/**
 * ContentSlider TS class for the ContentSlider TCA-CE
 */
export class ContentSlider
{

}

import Swiper from 'swiper';
import { Navigation, Pagination, EffectCoverflow } from 'swiper/modules';
Swiper.use([Navigation, Pagination, EffectCoverflow]);

let sw: Swiper | null = null;
let isMobile = window.innerWidth < 768;

function updateSwiper() {

  if( sw ) {
    sw.destroy(true, true);
  }

  if( isMobile ) {
    sw = new Swiper('.content-slider', {
      slidesPerView: 1,              
      centeredSlides: false,
      spaceBetween: 30,
      observer: true,
      observeParents: true,
      updateOnWindowResize: true,
      loop: true,
      pagination: { el: '.content-slider .swiper-pagination', clickable: true },
      navigation: {
        nextEl: '.content-slider .swiper-button-next',
        prevEl: '.content-slider .swiper-button-prev',
      },
      initialSlide: 1,                 
    });
  }
  else {
    sw = new Swiper('.content-slider', {
      slidesPerView: 'auto',
      spaceBetween: 0,
      observer: true,
      observeParents: true,
      updateOnWindowResize: true,
      loop: true,
      effect: 'coverflow',
      
      coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 300,
          modifier: 3,
          slideShadows: false 
        },
      centeredSlides: true,
      centeredSlidesBounds: true,
      pagination: { el: '.content-slider .swiper-pagination', clickable: true },
      navigation: {
        nextEl: '.content-slider .swiper-button-next',
        prevEl: '.content-slider .swiper-button-prev',
      },
      initialSlide: 1,     
       on: {
        init() {
          setMaxHeight();
        },
        slideChange() {
          setMaxHeight();
        }
      }
    });
  }
}

updateSwiper();
window.addEventListener('resize', () => {
  let isMobileNew = window.innerWidth < 768;
  if( isMobileNew != isMobile ) {
    isMobile = isMobileNew;
    updateSwiper();
  }
});

setMaxHeight();

function setMaxHeight(): void {
  const cards: NodeListOf<HTMLElement> =
    document.querySelectorAll('.content-slider .slide-card');

   if (!cards.length) return;

  // 1) Reset all heights so we can recalc correctly
  cards.forEach(card => {
    card.style.height = 'auto';
  });

  // 2) Measure max height
  let max = 0;

  cards.forEach(card => {
    const h = card.offsetHeight;
    if (h > max) {
      max = h;
    }
  });

  // 3) Apply max height
  cards.forEach(card => {
    card.style.height = `${max}px`;
  });
}


      
  




